"use client";

import { createContext, useContext, type ReactNode } from "react";

export const ICON_SETS = ["material", "phosphor"] as const;

export type IconSet = (typeof ICON_SETS)[number];

const IconSetContext = createContext<IconSet>("material");

export function IconSetProvider({
  value,
  children,
}: {
  value: IconSet;
  children: ReactNode;
}) {
  return <IconSetContext.Provider value={value}>{children}</IconSetContext.Provider>;
}

export function useIconSet(): IconSet {
  return useContext(IconSetContext);
}

export function isIconSet(value: unknown): value is IconSet {
  return value === "material" || value === "phosphor";
}
